import { render, staticRenderFns } from "./question1.vue?vue&type=template&id=555cba1e&scoped=true"
import script from "./question1.vue?vue&type=script&lang=js"
export * from "./question1.vue?vue&type=script&lang=js"
import style0 from "./question1.vue?vue&type=style&index=0&id=555cba1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555cba1e",
  null
  
)

export default component.exports